import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemsSection } from '../components/ProblemsSection';
import { AboutSection } from '../components/AboutSection';
import { MethodSection } from '../components/MethodSection';
import { OffersSection } from '../components/OffersSection';
import { ResourcesSection } from '../components/ResourcesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FooterCTA } from '../components/FooterCTA';
export function HomePage() {
  return <main data-id="element-1214">
      <HeroSection data-id="element-1215" />
      <ProblemsSection data-id="element-1216" />
      <AboutSection data-id="element-1217" />
      <MethodSection data-id="element-1218" />
      <OffersSection data-id="element-1219" />
      <ResourcesSection data-id="element-1220" />
      <TestimonialsSection data-id="element-1221" />
      <FooterCTA data-id="element-1222" />
    </main>;
}